import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DocumentationImg from '../i/documentation-banner.png';

const styles = {
  aboutUsSection: {
    margin: '30px',
    background: `url(${DocumentationImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: 10,
  },
  row: {
    display: 'flex',
    backgroundColor: 'rgba(9, 28, 41, 0.5)',
  },
  title: {
    transition: '.3s',
    fontWeight: '500',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontStyle: 'normal',
    color: 'white',
    fontSize: '35px',
    textAlign: 'center',
    lineHeight: '1.3',
    letterSpacing: '0px',
  },
  infoWrapper: {
    padding: '50px 0',
    fontSize: '16px',
    margin: '0px auto',
    height: '550px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    background: 'none',
  },
  text: {
    fontSize: '20px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: '400',
    margin: '20px 0',
    color: 'white',
  },
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
  },
  list: {
    maxWidth: 600,
  },
  selected: {
    color: 'white',
  },
};

class AboutUs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      responseText: '',
      disableButton1: false,
      disableButton2: false,
      disableButton3: false,
      disableButton4: false,
      correct: <div />,
    };
  }

  handleButton = (buttonName) => {
    if (this.state[buttonName]) {
      this.setState({
        [buttonName]: false,
      });
    } else {
      this.setState({
        [buttonName]: true,
      });
    }
  };

  handleText = (text) => {
    this.setState({
      responseText: text,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.aboutUsSection}>
        <div className={classes.row}>
          <span className={classes.imageContainer}>
            {/* <img className={classes.landingSectionImg} src={DocumentationImg} alt="" /> */}
          </span>
          <div className={classes.infoWrapper}>
            <div className={classes.title}>Who We Are</div>
            <div className={classNames(classes.title, classes.text)}>
              <List className={classes.list} component="nav">
                <ListItem
                  button
                  disabled={this.state.disableButton1}
                  onClick={() => {
                    this.handleButton('disableButton1');
                    this.handleText(
                      <div>
                        <h1>Not Quite!</h1>
                        <p>
                          Creating awesome products and dreaming up the newest innovations is part
                          of what we do, but not everything!
                        </p>
                      </div>,
                    );
                  }}
                >
                  <ListItemText
                    disableTypography
                    primary="A. a diverse team of dreamers and creators"
                  />
                </ListItem>
                <ListItem
                  button
                  disabled={this.state.disableButton2}
                  onClick={() => {
                    this.handleButton('disableButton2');
                    this.handleText(
                      <div>
                        <h1>Almost There!</h1>
                        <p>This is true.. in addition to all of the others..</p>
                      </div>,
                    );
                  }}
                >
                  <ListItemText
                    disableTypography
                    primary="B. a small team innovating the next big things"
                  />
                </ListItem>
                <ListItem
                  button
                  disabled={this.state.disableButton3}
                  onClick={() => {
                    this.handleButton('disableButton3');
                    this.handleText(
                      <div>
                        <h1>So Close!</h1>
                        <p>This is a trick question. We are the original hard-core nerds.</p>
                      </div>,
                    );
                  }}
                >
                  <ListItemText
                    disableTypography
                    primary="C. a group of extremely hard-core nerds"
                  />
                </ListItem>
                <ListItem
                  button
                  disabled={this.state.disableButton4}
                  onClick={() => {
                    this.handleText(
                      <div>
                        <h1>Correct!</h1>
                        <p>You guessed it! All of the above answers apply to us.</p>
                      </div>,
                    );
                  }}
                >
                  <ListItemText disableTypography primary="D. all of the above" />
                </ListItem>
                <ListItem>
                  <ListItemText disableTypography primary={this.state.responseText} />
                </ListItem>
              </List>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(AboutUs);

AboutUs.propTypes = {
  classes: PropTypes.object.isRequired,
};
